import React from 'react';

import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

export default function StyleContext({ context, desktopBreakpoint, children }) {
  const createTheme = (parentTheme) => {
    if (!context && !desktopBreakpoint) {
      return parentTheme;
    }
    let themeContext = { ...parentTheme.context };

    if (context) {
      if (Array.isArray(context)) {
        context.forEach((name) => {
          themeContext[name] = true;
        });
      } else if (typeof context === 'object') {
        themeContext = { ...themeContext, ...context };
      } else {
        themeContext[context] = true;
      }
    }

    const retTheme = {
      ...parentTheme,
      desktopBreakpoint: desktopBreakpoint || parentTheme.desktopBreakpoint,
      context: themeContext,
    };
    return retTheme;
  };

  return (
    <ThemeProvider theme={(parentTheme) => createTheme(parentTheme)}>
      {children}
    </ThemeProvider>
  );
}

StyleContext.propTypes = {
  children: PropTypes.node,
  context: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.object,
  ]).isRequired,
  desktopBreakpoint: PropTypes.string,
};
